
const semesters = [
    { id: "1", name: "תחילת שנה", range: [{ start: '09-01', end: '12-31' }] },
    { id: "2", name: "אמצע שנה", range: [{ start: '01-01', end: '04-30' }] },
    { id: "3", name: "סוף שנה", range: [{ start: '05-01', end: '08-31' }] },
]

export default semesters